import React from 'react'
import ExtraInfo from './extra_info.js';
import ComponentCard from "./ComponentCard"

import ComponentAdvisories from './ComponentAdvisories';
import ComponentExclusionsCard from "./ComponentExclusionsCard"
import { generateRegistryRequestLink } from '../../../classes/lib-common.js';


const sortPerFullyExcluded = (assessments) => {
	for (const assessment of assessments) {
		assessment.reports.sort((a, b) => {
			if (a.exclusions === a.advices.length) return 1
			if (b.exclusions === b.advices.length) return -1
			return a.dependency.library.name > b.dependency.library.name ? 1 : -1
		})
	}
}

export const TrustedComponents = ({ assessments, parentProps, parentState, toggledLanguages }) => {
	const cards = []
	for (const assessment of assessments) {
		if(toggledLanguages.includes(assessment.language))continue
		for (let index = 0; index < assessment.trusted.length; index++) {
			const trusted = assessment.trusted[index]
			const TrustedList = ComponentAdvisories({ report: trusted, otherVersionsCount: 0, parentProps, parentState, advicesData: null, forExclusions: false })
			const url = generateRegistryRequestLink(trusted.dependency.library.language, trusted.dependency.library.name, trusted.dependency.version)
			cards.push(
				<React.Fragment key={"security-card-key-exclusion-" + index + assessment.language}>
					<ComponentExclusionsCard index={index} url={url} name={trusted.dependency.library.name}
						version={trusted.dependency.version} scope={trusted.scope} transitive={trusted.transitive}
						language={assessment.language} findDependencyInTree={parentProps.findDependencyInTree}
						isLatest={parentProps.isLatest}
					>
						{TrustedList}
					</ComponentExclusionsCard>
				</React.Fragment>
			)
		}
	}
	return cards
}

const VulnerableComponents = (assessments, parentProps, parentState, advicesData, forExclusions, autofixPullRequests, filteredLanguages) => {
	const vulnerableCards = []
	const excludedCards = []


	for (const assessment of assessments) {
		if (filteredLanguages.includes(assessment.language)) continue
		for (let index = 0; index < assessment.reports.length; index++) {

			const report = assessment.reports[index]
			

			report.advices.sort((a, b) => {
				if (!a.exclusions) a.exclusions = []
				if (!b.exclusions) b.exclusions = []
				return a.exclusions.length - b.exclusions.length
			})

			const otherVersionsCount = report.otherVersionsCount = assessment.reports.filter(current => current.dependency.library.name === report.dependency.library.name && current.dependency.version !== report.dependency.version).length;

			const name = report.dependency.library.name,
				version = report.dependency.version,
				language = assessment.language;


			const url = generateRegistryRequestLink(language, name, version);
			const Advisories = ComponentAdvisories({ report, otherVersionsCount, parentProps, parentState, advicesData, onlyExclusions: false })
			const Exclusions = ComponentAdvisories({ report, otherVersionsCount, parentProps, parentState, advicesData, onlyExclusions: true })

			if (Advisories.length) {
				vulnerableCards.push(
					<React.Fragment key={"security-card-key-" + index + assessment.language}>
						<ComponentCard index={index} url={url} library={report.dependency.library} name={report.dependency.library.name} displayName={report.dependency.library.displayName}
							version={report.dependency.version} scope={report.scope} transitive={report.transitive}
							language={assessment.language} findDependencyInTree={parentProps.findDependencyInTree}
							isLatest={parentProps.isLatest} hasExclusions={Exclusions.length}
						>
							{Advisories}
						</ComponentCard>
						<ExtraInfo isAllowed={parentProps.isSafeVersionAllowed} library={report.dependency} safeVersions={report.safeVersions} language={assessment.language} autofixPullRequests={autofixPullRequests || {entries:[], createdAt: null}}/>
					</React.Fragment>
				)

			}
			if (Exclusions.length) {

				excludedCards.push(
					<React.Fragment key={"security-card-key-exclusion-" + index + assessment.language}>
						<ComponentExclusionsCard index={index} url={url} name={report.dependency.library.name}
							version={report.dependency.version} scope={report.scope} transitive={report.transitive}
							language={assessment.language} findDependencyInTree={parentProps.findDependencyInTree}
							isLatest={parentProps.isLatest}
						>
							{Exclusions}
						</ComponentExclusionsCard>
					</React.Fragment>
				)
			}



		}
	}
	if (forExclusions) return excludedCards
	return vulnerableCards
}

export const ComponentsList = ({ forExclusions, assessments, parentProps, parentState, advicesData, autofixPullRequests, toggledLanguages}) => {

	sortPerFullyExcluded(assessments)
	return VulnerableComponents(assessments, parentProps, parentState, advicesData, forExclusions, autofixPullRequests, toggledLanguages)

}
